const PHONE_NUMBER = /^([+]?[0-9]{5,15})?$/;
const ZIP_CODE = /^([0-9]{0,5})$/;
const MILEAGE = /^([1-9][0-9]+)$/;

export default { PHONE_NUMBER, ZIP_CODE, MILEAGE };
